import React, { useEffect, useState } from 'react';
import {
  ToggleButton,
  Toast,
  useT,
  getNewsletterStatus,
  updateNewsletter,
  NewsletterEmailModal,
  NewsletterTurnOffModal,
  subscribedToastMessage,
  unsubscribedToastMessage,
} from '@repo/common';

/**
 * 뉴스레터 수신 동의 토글. 켤 때 보낼 주소가 없으면(Apple 이메일 가리기) 주소를 먼저 받고,
 * 끌 때는 확인 모달을 거친다.
 */
export default function NewsletterSettingRow() {
  const t = useT();
  const [status, setStatus] = useState(null);
  // 'email' | 'turnOff' | null
  const [modal, setModal] = useState(null);
  const [busy, setBusy] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    getNewsletterStatus()
      .then(setStatus)
      .catch((error) => console.error('Newsletter status could not be loaded', error));
  }, []);

  const subscribe = async (email) => {
    const next = await updateNewsletter({ subscribed: true, email, source: 'SETTINGS' });
    setStatus(next);
    setModal(null);
    setToastMessage(subscribedToastMessage(next.email));
  };

  const handleToggle = async (on) => {
    if (!status || busy) return;
    if (!on) {
      setModal('turnOff');
      return;
    }
    if (status.needsEmail) {
      setModal('email');
      return;
    }
    setBusy(true);
    try {
      await subscribe();
    } catch (error) {
      console.error('Newsletter subscribe failed', error);
    } finally {
      setBusy(false);
    }
  };

  const handleTurnOff = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const next = await updateNewsletter({ subscribed: false, source: 'SETTINGS' });
      setStatus(next);
      setModal(null);
      setToastMessage(unsubscribedToastMessage(next.unsubscribedAt));
    } catch (error) {
      console.error('Newsletter unsubscribe failed', error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className='flex items-center w-full'>
        <div className='flex min-w-0 flex-1 flex-col gap-0.5 pr-2'>
          <p className='typo-b14Strong text-text-primary'>
            {t('Newsletter and offers', '뉴스레터 및 혜택 소식')}
          </p>
          <p className='typo-b12 text-text-placeholder'>
            {t(
              'Get our weekly newsletter and news about programs and discounts',
              '주간 뉴스레터와 프로그램·할인 소식을 받아보세요',
            )}
          </p>
          {status?.subscribed && status.email && (
            <p className='typo-b12 text-text-secondary break-all'>{status.email}</p>
          )}
        </div>
        <ToggleButton value={Boolean(status?.subscribed)} onChange={handleToggle} />
      </div>

      <NewsletterEmailModal
        isOpen={modal === 'email'}
        variant='existing'
        onSubmit={subscribe}
        onCancel={() => setModal(null)}
      />
      <NewsletterTurnOffModal
        isOpen={modal === 'turnOff'}
        onTurnOff={handleTurnOff}
        onKeep={() => setModal(null)}
      />
      {toastMessage && (
        <div className='fixed bottom-6 left-0 right-0 px-4 z-[1000] flex justify-center'>
          <Toast
            type='success'
            state='white'
            title={toastMessage}
            direction='up'
            customWidth='auto'
            onClose={() => setToastMessage('')}
          />
        </div>
      )}
    </>
  );
}
